import { useState } from "react";
import { ShieldCheck, ChevronUp, ChevronDown } from "lucide-react";

export function PrivacyFooter() {
  const [open, setOpen] = useState(false);
  return (
    <footer className="no-print max-w-2xl mx-auto px-5 pb-24 pt-4">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-3 cc-card p-4 text-left"
        data-testid="privacy-toggle"
        aria-expanded={open}
      >
        <span className="flex items-center gap-3">
          <ShieldCheck className="h-5 w-5 text-[hsl(var(--olivo))]" aria-hidden="true" />
          <span className="text-sm font-medium">Aviso de privacidad (demostración)</span>
        </span>
        {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </button>
      {open && (
        <div className="mt-2 cc-card p-4 text-sm text-[hsl(var(--muted-foreground))] leading-relaxed" data-testid="privacy-content">
          <ul className="space-y-2 list-disc pl-5">
            <li>No solicita identificadores (nombre, teléfono, correo, ciudad, fecha exacta).</li>
            <li>Procesa tus respuestas localmente en tu navegador.</li>
            <li>No guarda ni envía tus respuestas: al recargar la página se borran.</li>
            <li>No introduzcas datos personales reales. Este prototipo es sólo demostrativo.</li>
            <li>WhatsApp es un servicio externo; nada se envía automáticamente.</li>
            <li>Texto provisional sujeto a revisión jurídica.</li>
          </ul>
        </div>
      )}
    </footer>
  );
}
